import { Box, styled } from '@treneo/shared/ui';

export const StyledWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;

  &:hover {
    cursor: pointer;
  }
`;
